export function toDateOnlyString(date: Date | string | null | undefined): string {
  if (!date) {
    return '';
  }

  if (typeof date === 'string') {
    const dateOnly = date.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
      return dateOnly;
    }

    const parsed = new Date(date);
    if (Number.isNaN(parsed.getTime())) {
      return '';
    }

    return toDateOnlyString(parsed);
  }

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
